import React from 'react'
import { titleCase } from 'change-case'
import Linkify from 'react-linkify'
import './listingErrors.scss'

interface Props {
  errors: any
}

const GENERIC_EBAY_ERROR_CODES = new Set(['17460'])

const ebayErrorSortRank = (key: string): number => {
  if (GENERIC_EBAY_ERROR_CODES.has(key)) return 2
  if (/^\d+$/.test(key)) return 0
  return 1
}

const formatErrorLabel = (key: string): string => {
  if (/^\d+$/.test(key)) return `eBay ${key}`
  return titleCase(key)
}

const formatErrorMessages = (messages: any): string => {
  if (Array.isArray(messages)) return messages.join(' — ')
  if (messages == null) return ''
  return JSON.stringify(messages)
}

const ListingErrors: React.FC<Props> = ({ errors }) => {
  if (!errors) return null
  if (typeof errors === 'string') return <Linkify>{errors}</Linkify>
  if (typeof errors !== 'object' || Object.keys(errors).length === 0) return null

  const sortedKeys = Object.keys(errors).sort((a, b) => {
    const rankDiff = ebayErrorSortRank(a) - ebayErrorSortRank(b)
    if (rankDiff !== 0) return rankDiff
    return a.localeCompare(b)
  })

  return (
    <ul className="tooltip-listing-error">
      {sortedKeys.map(err => (
        <li key={err}>
          <strong>{formatErrorLabel(err)}</strong> <Linkify>{formatErrorMessages(errors[err])}</Linkify>
        </li>
      ))}
    </ul>
  )
}
export default ListingErrors
